import {Reason} from './Reason.model';

export class SelectAddOnsModalData {
    selectedReason: Reason;
    availableAddOnsForSelectedReason: Reason[];
    selectedAddOns: Reason[];
}
